import { render } from "./rental_body_details_qna.vue?vue&type=template&id=8b7d4ec8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__